import {createApp} from 'vue'
import DeleteFrivilligjobOverlay from './DeleteFrivilligjobOverlay'

const el = '.kb-component--delete-frivilligjob-overlay'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((DeleteFrivilligjobOverlayDOM)=>{
            const component = createApp(DeleteFrivilligjobOverlay).use(Store)
            component.mount(DeleteFrivilligjobOverlayDOM)
        })
    }
}